/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import _ from 'lodash';

import template from './tooltip.stache';

import { getPercentStr, getTooltipObject } from '../tooltipHelpers';
import { getTooltipLabel } from '../types';

export function isPreHole(id) {
    return id.split('_')[1] === '0';
}

export default Component.extend({
    tag: 'probability-tooltip',
    template,
    viewModel: {
        define: {
            round: {
                type: 'number',
                value: undefined,
            },
            showLeaders: {
                type: 'boolean',
                value: false,
            },
            probabilityType: {
                type: 'string',
            },
            probabilityLabel: {
                type: 'string',
            },
            pageType: {
                type: 'string',
            },
            player: {
                type: 'object',
            },
            tooltips: {
                type: 'object',
                value: {},
            },
            activeTooltipId: {
                value: 'string',
            },
            activeTooltip: {
                set(data) {
                    const tooltipData = _.map(data.serialize(), (item) =>
                        Object.assign({}, item, {
                            probability: `${getPercentStr(item.probability)}%`,
                        }),
                    );

                    return tooltipData;
                },
            },
        },
        getRoundData() {
            const round = this.attr('round');
            if (round) {
                const roundData =
                    _.find(
                        this.attr('probability'),
                        (roundData) => roundData.roundNumber === Number(round),
                    ) || {};
                return [roundData];
            }

            return this.attr('probability');
        },
        setActiveTooltips(id) {
            const activeTooltips = _.get(this.attr('tooltips'), id, []);

            this.attr('activeTooltip', activeTooltips);
        },
        updateTooltips() {
            const roundData = this.getRoundData();
            const showLeaders = this.attr('showLeaders');

            this.attr('tooltips', getTooltipObject(roundData, showLeaders));
            this.attr(
                'probabilityLabel',
                getTooltipLabel(this.attr('probabilityType')),
            );
        },
    },
    events: {
        inserted() {
            this.viewModel.bind('activeTooltipId', (__, id) =>
                this.viewModel.setActiveTooltips(id),
            );
            this.viewModel.bind('round', () => this.viewModel.updateTooltips());
            this.viewModel.bind('showLeaders', () =>
                this.viewModel.updateTooltips(),
            );
            this.viewModel.bind('probabilityType', () =>
                this.viewModel.updateTooltips(),
            );
            this.viewModel.bind('probability', () =>
                this.viewModel.updateTooltips(),
            );

            this.viewModel.updateTooltips();
        },
    },
});
